export default {
    path: '/shenbi/shiyong/:shiyong/:yq',
    name: 'Shenbi.Shiyong',
    component: () => import(/* webpackChunkName: "form" */ '@/views/modules/shenbi/Shiyong.vue'),
    hiddenInMenu: true,
    meta: {
      title: '神笔试用',
      icon: 'database',
    },
  };
  